import { createSlice } from '@reduxjs/toolkit';
import {
  deleteUserPhotos,
  deleteUserVideos,
  fetchUserPhotos,
  fetchUserVideos,
} from './operations';

const initialState = {
  photoList: [],
  videoList: [],
  isLoading: false,
};

const handlePending = state => {
  state.isLoading = true;
  state.error = null;
};
const handleRejected = (state, { payload }) => {
  state.isLoading = false;
  state.error = payload;
};
export const sliceUserFiles = createSlice({
  name: 'UserFiles',
  initialState,
  reducers: {
    setPhotoList(state, { payload: userData }) {
      state.photoList = userData;
    },
    setVideoList(state, { payload: userData }) {
      state.videoList = userData;
    },
  },

  extraReducers: builder => {
    builder
      .addCase(fetchUserPhotos.fulfilled, (state, { payload: photoList }) => {
        state.isLoading = false;
        state.photoList = photoList;
      })
      .addCase(fetchUserVideos.fulfilled, (state, { payload: videoList }) => {
        state.isLoading = false;
        state.videoList = videoList;
      })
      .addCase(deleteUserPhotos.fulfilled, (state, { payload: photoItem }) => {
        state.isLoading = false;
        state.photoList = state.photoList.filter(el => el._id != photoItem._id);
      })
      .addCase(deleteUserVideos.fulfilled, (state, { payload: videoItem }) => {
        state.isLoading = false;
        state.videoList = state.videoList.filter(el => el._id != videoItem._id);
      })
      .addCase(fetchUserPhotos.pending, handlePending)
      .addCase(fetchUserVideos.pending, handlePending)
      .addCase(deleteUserPhotos.pending, handlePending)
      .addCase(deleteUserVideos.pending, handlePending)
      .addCase(fetchUserPhotos.rejected, handleRejected)
      .addCase(fetchUserVideos.rejected, handleRejected)
      .addCase(deleteUserPhotos.rejected, handleRejected)
      .addCase(deleteUserVideos.rejected, handleRejected);
  },
});

export const { setPhotoList, setVideoList } = sliceUserFiles.actions;
export default sliceUserFiles.reducer;
